import styled from "styled-components/native";

export const Logo = styled.Image`
  width: 163px;
  height: 54px;
`;

export const HeaderContainer = styled.View`
  padding: 0.5rem 2rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
